// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment :
{
  production: boolean;                              // Build-time: If True, optimize code.
  envName: 'dev' | 'staging' | 'prod';              // Runtime logic: If prod, run Live business logic.
  orgId: 'admin';
  appBaseUrl: string;
  parrotApiBaseUrl: string;
  apiBaseUrl: string;
  authServerUrl: string;
  clientSecret: string;
  clientId: string;
} = {
  production: false,
  envName: 'dev',
  orgId: 'admin',
  appBaseUrl: 'https://mif-subscription-admin.dev.storyshaper.io/',
  authServerUrl: 'https://hub-staging.storyshaper.io/green/',
  parrotApiBaseUrl: 'https://hub-staging.storyshaper.io/mif_proxy/parrot', // if run using 'start dotnet watch run'
  apiBaseUrl: 'https://hub-staging.storyshaper.io/mif_proxy/subscription',
  clientSecret: '',
  clientId: ''
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
